import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import "./Footer.css"; // Import your CSS file for styling

function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="footer-container">
        <div className="footer-section contact">
          <h4>Contact Us</h4>
          <p>Email: satyasocialaudit@gmail.com</p>
          <p>Phone: (+91) 9937420134</p>
        </div>

        <div className="footer-section categories">
          <h4>Other Links</h4>
          <ul className="category-links">
            <li>
              <a
                href="https://balasore.odisha.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                District Website
              </a>
            </li>
            <li>
              <a
                href="https://ossaat.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                OSSAAT
              </a>
            </li>
            <li>
              <a
                href="https://odisha.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Odisha Govt.
              </a>
            </li>
            <li>
              <a
                href="https://www.india.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                National Portal
              </a>
            </li>
            <li>
              <a
                href="https://www.digitalindia.gov.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Digital India
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-section useful-links">
          <h4>Useful Links</h4>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about">About Us</a>
            </li>
            <li>
              <a href="/services">Services</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="social-media">
        <h4>Follow Us</h4>
        <div className="social-icons">
          <a
            href="https://www.facebook.com"
            className="social-icon"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <Facebook size={24} />
          </a>
          <a
            href="https://www.twitter.com"
            className="social-icon"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
          >
            <Twitter size={24} />
          </a>
          <a
            href="https://www.instagram.com"
            className="social-icon"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <Instagram size={24} />
          </a>
          <a
            href="https://www.linkedin.com"
            className="social-icon"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <Linkedin size={24} />
          </a>
        </div>
      </div>
      <div className="footer-section download-apps">
        <h4>Download Our App</h4>
        <div className="app-downloads">
          <a
            href="/SocialAudit.exe"
            download
            className="download-btn windows-btn"
            title="Download Windows App"
          >
            <svg className="app-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801" />
            </svg>
          </a>
          <a
            href="/application.apk"
            download
            className="download-btn android-btn"
            title="Download Android App"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/226/226770.png"
              alt="Android"
              className="app-icon"
            />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} satyasocialaudit.in. All rights
          reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
